import {
  UPLOAD_IMAGE,
  START,
  TICK,
  FAIL,
  SUCCESS
} from "../constants/action-types";

import request from "superagent";
import {API_IMAGES} from "../constants/api";
import {addImage} from "./add-image";
export const uploadImage = (data, fields, shutterstock) => (
  dispatch,
  getState
) => {
  dispatch({
    type: UPLOAD_IMAGE + START
  });
  const formData = new FormData();
  formData.append(`authenticity_token`, getState().authenticityToken);
  if (typeof data === `string`) {
    formData.append(`image[remote_picture_url]`, data);

    if (shutterstock) {
      formData.append(`image[shutter_stock_params][image_id]`, shutterstock.id);
      formData.append(
        `image[shutter_stock_params][search_query]`,
        shutterstock.searchRequest
      );
      formData.append(
        `image[shutter_stock_params][contributor_id]`,
        shutterstock.contributor
      );
    }
  } else {
    formData.append(`image[picture]`, data);
  }
  request
    .post(API_IMAGES)
    .send(formData)
    .on(`progress`, (e) => {
      if (e.direction === `upload`) {
        dispatch({
          type: UPLOAD_IMAGE + TICK,
          payload: {
            progress: e.percent
          }
        });
      }
    })
    .end((error, response) => {
      if (error) {
        dispatch({
          type: UPLOAD_IMAGE + FAIL,
          error
        });
        throw error;
      } else {
        const json = JSON.parse(response.text);
        dispatch({
          type: UPLOAD_IMAGE + SUCCESS
        });
        if (json.id) {
          dispatch(addImage(json.id, fields));
        }
      }
    });
};
